var _rect, _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewIconAngryOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#FDBD38"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1,
    fill: "#505768"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 1,
    fill: "#505768"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16C15.7761 16 16.0033 15.775 15.9692 15.501C15.7236 13.5274 14.0402 12 12 12C9.95985 12 8.27643 13.5274 8.03082 15.501C7.99672 15.775 8.22386 16 8.5 16C8.77614 16 8.99563 15.7745 9.04113 15.5021C9.2783 14.0822 10.5128 13 12 13C13.4872 13 14.7217 14.0822 14.9589 15.5021C15.0044 15.7745 15.2239 16 15.5 16Z",
    fill: "#505768"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIconAngryOn);
export default __webpack_public_path__ + "static/media/view_icon_angry_on.a2f381e773daf7943d445b9a5e4b0eab.svg";
export { ForwardRef as ReactComponent };